// extracted by mini-css-extract-plugin
export default {"wrapper":"oNeTE","wrapper-resize":"Tk0Sd","wrapper-move":"UIgiZ","container":"DZyg_","content":"RHfqQ"};